import React, { useEffect, useState } from "react";
import { LIVE_FEEDS } from "@/lib/company";
import { Radio } from "lucide-react";

const FeedTile = ({ feed, index }) => {
  const [clock, setClock] = useState("");
  useEffect(() => {
    const tick = () => setClock(new Date().toLocaleTimeString("en-US", { hour12: false }));
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      data-testid={`live-feed-${feed.id}`}
      className="group relative aspect-video overflow-hidden rounded-xl border border-white/10 bg-slate-900"
    >
      <img
        src={feed.img}
        alt={feed.label}
        className="kenburns h-full w-full object-cover opacity-90"
        style={{ animationDelay: `${index * -4}s` }}
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-950/10 to-slate-950/40" />
      {/* scanline sheen */}
      <div className="pointer-events-none absolute inset-0 live-scan opacity-30" />

      <div className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full border border-rose-500/50 bg-rose-950/70 px-2.5 py-1 backdrop-blur">
        <span className="h-2 w-2 animate-pulse rounded-full bg-rose-500" />
        <span className="font-mono text-[10px] font-bold uppercase tracking-widest text-rose-200">Live</span>
      </div>
      <div className="absolute right-3 top-3 rounded bg-black/50 px-2 py-0.5 font-mono text-[11px] text-emerald-300 backdrop-blur">
        {clock}
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-4">
        <p className="font-mono text-[10px] uppercase tracking-widest text-orange-400">CAM {feed.id}</p>
        <p className="text-sm font-bold text-white">{feed.label}</p>
        <p className="text-xs text-slate-300">{feed.city}</p>
      </div>
    </div>
  );
};

export const LiveOperations = () => {
  return (
    <section className="border-t border-white/10 bg-[#0B0F17] py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="flex items-center gap-3">
          <Radio className="h-5 w-5 text-rose-500" />
          <p className="text-xs font-mono uppercase tracking-[0.25em] text-rose-400">Live Operations Feed</p>
        </div>
        <h2 className="mt-3 text-2xl font-black tracking-tight text-white sm:text-3xl lg:text-4xl">
          The network, in motion — right now
        </h2>
        <p className="mt-2 max-w-2xl text-sm text-slate-400">
          Real-time views across our hubs, docks, last-mile routes and air gateways. Every parcel you track moves through operations like these.
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {LIVE_FEEDS.map((feed, i) => (
            <FeedTile key={feed.id} feed={feed} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
